// Module
var code = "<h2 class=\"interiorSectionHeading mt-0\">Account Access</h2> <p><strong>Creating an online account is easy, and lets you:</strong></p> <ul> <li> Make a payment</li> <li> View the payment status</li> <li> Check the balance and other loan details for your loans</li> <li> Update your personal information</li> </ul> ";
// Exports
export default code;